module.exports = __webpack_public_path__ + "img/021.838c6d7b.png";